import React from "react";
import { Link } from "../components/L";
import { MapPin, ChevronRight } from "lucide-react";
import Seo from "../components/Seo";
import CTABand from "../components/CTABand";
import { cities, cityLabel } from "../mock";
import { useLang } from "../context/LanguageContext";

const Cities = () => {
  const { lang, t } = useLang();
  const cp = t.citiesPage;
  const seo = lang === "de"
    ? { title: "Putzfrau in Ihrer Stadt – Schweizweit | MyCleaner.ch", description: "Geprüfte Putzfrauen & Haushaltshilfe in Zürich, Zug, Luzern, Baden, Bern, Basel, Genf, Lausanne und der ganzen Schweiz. Fixpreis 43.90 CHF/Std., immer dieselbe Putzfrau.", keywords: "Putzfrau Zürich, Putzfrau Zug, Putzfrau Luzern, Putzfrau Baden, Putzfrau Genf, Putzfrau Lausanne, Putzfrau Schweiz, Haushaltshilfe Stadt" }
    : { title: "Cleaner in your city – across Switzerland | MyCleaner.ch", description: "Vetted cleaners & home help in Zurich, Zug, Lucerne, Baden, Bern, Basel, Geneva, Lausanne and all of Switzerland. Flat rate CHF 43.90/hr, always the same cleaner.", keywords: "cleaner Zurich, cleaner Zug, cleaner Lucerne, cleaner Geneva, cleaner Lausanne, cleaner Switzerland, home help city" };

  return (
    <div>
      <Seo pageKey="cities" title={seo.title} description={seo.description} keywords={seo.keywords} />

      <section className="pt-[116px] pb-16 bg-gradient-to-b from-amber-50 to-white">
        <div className="max-w-[820px] mx-auto px-5 md:px-6 text-center">
          <p className="text-teal-600 font-semibold text-sm tracking-wide uppercase mb-3">{cp.eyebrow}</p>
          <h1 className="font-head font-extrabold text-4xl md:text-5xl leading-tight text-slate-900 mb-5">{cp.title}</h1>
          <p className="text-lg text-slate-600">{cp.subtitle}</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1200px] mx-auto px-5 md:px-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cities.map((c) => (
              <Link key={c.slug} to={`/putzfrau/${c.slug}`} className="group bg-white rounded-2xl border border-slate-100 p-6 hover:border-teal-600 hover:shadow-lg transition-all">
                <div className="flex items-center justify-between mb-4">
                  <span className="w-12 h-12 rounded-xl bg-teal-50 flex items-center justify-center"><MapPin className="w-6 h-6 text-teal-700" /></span>
                  <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-teal-600 transition-colors" />
                </div>
                <h2 className="font-head font-bold text-slate-900 text-xl mb-1">{t.term} {cityLabel(c, lang)}</h2>
                <p className="text-slate-500 text-sm mb-3">{cp.canton} {c.canton} · {cp.from}</p>
                <p className="text-slate-600 text-sm leading-relaxed">{cp.cardDesc(c.quarters.slice(0,3).join(", "))}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </div>
  );
};

export default Cities;
